import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44e37dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "ads_click", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!

  return (_ctx.message.content.text && _ctx.message.content.text.trim().length > 0)
    ? (_openBlock(), _createBlock(_component_message, {
        key: 0,
        message: _ctx.message,
        class: "text-message"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["text-bubble", [_ctx.message.sender]])
          }, [
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.message.content.text), 1)
          ], 2)
        ]),
        _: 1
      }, 8, ["message"]))
    : _createCommentVNode("", true)
}